import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const PLANTATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PlantationType')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PlantationType.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
  FieldBuilder
    .checkbox('isRotationType', 'Entity.PlantationType.IsRotationType')
    .build(),
];

export const PLANTATIONTYPE_CONFIG = {
  entityName: 'PlantationType',
  localizationKey: 'Planning::Entity.PlantationType',
  fields: PLANTATIONTYPE_FIELDS,
  permission: 'PlanningOperation.PlantationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
